import { Box, Button, CardContent, TextField, Grid, CircularProgress, Typography } from "@mui/material"
import { useState } from "react"
import Dialog from "@mui/material/Dialog"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogTitle from "@mui/material/DialogTitle"
import DeleteIcon from "@mui/icons-material/Delete"
import PaperComponent from "./paper-component"
import { ProgressWrapper } from "components/common-styles"

const ConfirmDialog = ({ open, onClose, onConfirm }) => {
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [isValid, setIsValid] = useState(false)

  const handleClose = () => {
    onClose()
  }

  const handleConfirm = async () => {
    if (!isValid) return

    setIsSubmitting(true)
    await onConfirm()
    setIsSubmitting(false)
    onClose()
  }

  const onTextChanged = event => {
    setIsValid(event.target.value.toUpperCase() === "DEL")
  }

  const onKeyPress = event => {
    if (event.key === "Enter") {
      handleConfirm()
    }
  }

  return (
    <Dialog open={open} onClose={onClose} PaperComponent={PaperComponent} aria-labelledby="draggable-dialog-title">
      <DialogTitle style={{ cursor: "move" }} id="draggable-dialog-title">
        Confirmation
      </DialogTitle>
      <DialogContent dividers>
        <CardContent>
          <Grid container spacing={3} style={{ textAlign: "center" }}>
            <Grid item md={12} xs={12}>
              <DeleteIcon color="primary" fontSize="large" />
            </Grid>

            <Grid item md={12} xs={12}>
              <Typography color="textPrimary" gutterBottom variant="h5">
                Are you sure to delete?
              </Typography>
              <Typography color="textPrimary" gutterBottom>
                Once deleted, this record can not be recovered.
              </Typography>
              <Box>
                Please type <b>DEL</b> in the textbox confirm
              </Box>
            </Grid>

            <Grid item md={12} xs={12}>
              <TextField
                id="txtConfirmText"
                autoFocus={true}
                placeholder="_ _ _"
                onChange={onTextChanged}
                onKeyPress={onKeyPress}
                InputProps={{
                  style: { width: 100 },
                  inputProps: {
                    style: { textAlign: "center", textTransform: "uppercase" },
                    maxLength: 3,
                  },
                }}
              />
            </Grid>
          </Grid>
        </CardContent>
      </DialogContent>
      <DialogActions>
        {isSubmitting ? (
          <ProgressWrapper>
            <CircularProgress size={32} />
          </ProgressWrapper>
        ) : (
          <>
            <Button id="btnCancel" onClick={handleClose} color="info" variant="outlined">
              Cancel
            </Button>
            <Button id="btnOKConfirm" onClick={handleConfirm} disabled={!isValid} variant="contained">
              OK
            </Button>
          </>
        )}
      </DialogActions>
    </Dialog>
  )
}

export default ConfirmDialog
